import React, { useEffect, useRef, useState } from 'react'
import { View, StyleProp, ViewStyle, FlatList } from 'react-native'
import { MonthSelector } from './MonthSelector'
import moment from 'moment-timezone'
import { DayItem } from './DayItem'
import { useTranslation } from 'react-i18next'

interface Props {
  style?: StyleProp<ViewStyle>
  getDate: (value: string) => void
  initialValue?: string | null
}

interface Value {
  month: number
  year: number
  day: number | null
}
export const DaySelector = ({ style, getDate, initialValue }: Props) => {
  const { t } = useTranslation()
  const [listDays, setListDays] = useState<number[]>([])
  const isFirstRender = useRef(true)

  const [values, setValues] = useState<Value>(() => {
    if (initialValue) {
      const year = +initialValue.split('-')[0]!
      const month = +initialValue.split('-')[1]!
      const day = +initialValue.split('-')[2]!
      return {
        month,
        year,
        day,
      }
    }

    return {
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      day: null,
    }
  })

  const [daysOfTheMonth, setDayOfTheMonth] = useState(
    moment(`${values.year}-${values.month}`, 'YYYY-MM').daysInMonth(),
  )

  useEffect(() => {
    setDayOfTheMonth(
      values.month === moment().month() + 1
        ? moment().date()
        : moment(`${values.year}-${values.month}`, 'YYYY-MM').daysInMonth(),
    )

    if (!isFirstRender.current) {
      handleSetValues({ value: null, name: 'day' })
    }
    isFirstRender.current = false
  }, [values.month, values.year])

  useEffect(() => {
    const listOfDay = Array.from({ length: daysOfTheMonth }, (_, i) => i + 1)
    setListDays(listOfDay.reverse())
  }, [daysOfTheMonth])

  useEffect(() => {
    if (values.day !== null) {
      getDate(
        moment(`${values.year}-${values.month}-${values.day}`, 'YYYY-MM-DD').format('YYYY-MM-DD'),
      )
    }
  }, [values.day])

  const handleSetValues = ({ value, name }: { value: number | null; name: keyof Value }) => {
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleFormatData = (listDays: number[]) =>
    listDays.map((day) => ({
      id: day,
      name: moment(
        `${values.year}-${values.month}-${String(day).padStart(2, '0')}`,
        'YYYY-MM-DD',
      ).format('ddd'),
    }))

  return (
    <View style={style}>
      <MonthSelector
        initialValue={{ month: values.month, year: values.year }}
        getValue={(values) => {
          handleSetValues({ value: values.month, name: 'month' })
          handleSetValues({ value: values.year, name: 'year' })
        }}
      />

      <FlatList
        horizontal
        style={{ marginTop: 10 }}
        data={handleFormatData(listDays)}
        renderItem={({ item }) => (
          <DayItem
            translation={t}
            isSelected={values.day === item.id}
            day={item}
            getDaySelected={(day) =>
              handleSetValues({ value: day === values.day ? null : day, name: 'day' })
            }
          />
        )}
      />
    </View>
  )
}
